import { createFileRoute } from '@tanstack/react-router'

import { RouteModal } from '@/components/route-modal'

import { PromotionForm } from '../-promotion-form'

export const Route = createFileRoute('/_authenticated/_general/promotions/$promotionUuid/edit')({
	component: RouteComponent,
	staticData: {
		crumb: ({ context: { L } }) => L.Promotions.EditTitle()
	}
})

function RouteComponent() {
	const { promotionUuid } = Route.useParams()
	return (
		<RouteModal asDrawer requiresData loader={async api => await api.getPromotion({ path: { promotionUuid } })}>
			{data => <PromotionForm promotion={data} />}
		</RouteModal>
	)
}
